import { type HTMLAttributes, forwardRef } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const glassCard = cva(
  "glass glass-card relative overflow-hidden",
  {
    variants: {
      tone: {
        plain: "",
        glow: "ring-glow",
        hover: "glass-card-hover",
      },
      pad: {
        sm: "p-5",
        md: "p-6 sm:p-7",
        lg: "p-7 sm:p-9",
        none: "p-0",
      },
      radius: {
        md: "rounded-2xl",
        lg: "rounded-[1.4rem]",
        xl: "rounded-[1.8rem]",
        none: "rounded-none",
      },
    },
    defaultVariants: { tone: "plain", pad: "md", radius: "lg" },
  },
);

export interface GlassCardProps
  extends HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof glassCard> {}

export const GlassCard = forwardRef<HTMLDivElement, GlassCardProps>(
  ({ className, tone, pad, radius, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(glassCard({ tone, pad, radius }), className)}
      {...props}
    />
  ),
);
GlassCard.displayName = "GlassCard";
